import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
	state: {
		token: '',
		status: '',
	},
	mutations: {
		authRequest: (state) => {
			state.status = 'loading';
		},
		authSuccess: (state, {token, rememberMe}) => {
			state.status = 'success';
			state.token = token;
			Vue.storage.setItem('user-token', token); // store the token in localstorage
			axios.defaults.headers.common['x-access-token'] = token;
		},
		authError: (state) => {
			state.status = 'error';
		},
		authLogout: (state) => {
			state.status = 'logout';
			state.token = '';
			Vue.storage.removeItem('user-token'); // clear your customer's token from localstorage
			delete axios.defaults.headers.common['x-access-token'];
		},
	},
	actions: {
		authRequest ({commit, dispatch}, login) {
			return new Promise((resolve, reject) => { // The Promise used for router redirect in login
				commit('authRequest');
				
				let params = new URLSearchParams();
				params.append('username', login.username);
				params.append('password', login.password);

				axios.post(`/admin/users/login`, params)
				.then(resp => {
					let token = resp.data.response.token;
					commit('authSuccess', {token: token, rememberMe: login.rememberMe});
					// you have your token, now log in your customer :)
					dispatch('userRequest')
					.then(() => {

					})
					.catch((err) => {
						
					});

					resolve(resp);
				})
				.catch(err => {
					// dispatch('authError', {err: err});
					reject(err);
				});
			});
		},
		authLogout({commit, dispatch}) {
			return new Promise((resolve, reject) => {
				axios.get(`/admin/users/logout`)
				.then(resp => {
					commit('authLogout');
					resolve();
				})
				.catch(err => {
					// dispatch('authError', {err: err});
					reject(err);
				});
			})
		},
		// authError({commit, dispatch}, {err}) {
		// 	if (err.message === 'Network Error') {
		// 		commit('authError');
		// 		dispatch('setConnectionError', {connectionError: true});
		// 		console.log('Network error')
		// 	} else {
		// 		let response = err.response;
		// 		let resp = response.data.response;
		// 		if (resp) {
		// 			let cause = resp.cause;
		// 			if (cause && cause === 'authentication') {
		// 				commit('authLogout');
		// 				console.log('Authentication error');
		// 			}
		// 		}
		// 	}
		// },
		registrationRequest ({commit}, data) {
			return new Promise((resolve, reject) => { // The Promise used for router redirect in registration
				let params = new URLSearchParams();
				params.append('name', data.name);
				params.append('username', data.username);
				params.append('email', data.email);
				params.append('password', data.password);
				axios.post(`/admin/users/create`, params)
				.then(resp => {
					resolve(resp);
				})
				.catch(err => {
					reject(err);
				});
			});
		}
	}, getters: {
		isAuthenticated: state => !!state.token && state.status === 'success',
		authStatus: state => state.status,
	}
}
